import {
  TEXTBOX_CHANGE_TEXT,
} from './action-names';

export function changeText(data) {
  return {
    type: TEXTBOX_CHANGE_TEXT,
    ...data
  };
};



// WEBPACK FOOTER //
// ./app/header-builder/actions/textbox-element-actions.js